import { render, staticRenderFns } from "./AdminAccountsRegistry.vue?vue&type=template&id=2952c386&lang=pug&"
import script from "./AdminAccountsRegistry.vue?vue&type=script&lang=js&"
export * from "./AdminAccountsRegistry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports